import React, { useState, useEffect, useRef, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase, Menu, MenuItem } from '@material-ui/core';
import { FormatColorFill } from '@material-ui/icons';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Droppable } from 'react-beautiful-dnd';
import Card from '../../../../components/StaffCard/drag';
import { MoreIcon, ReNameIcon, CloseIcon, AddIcon, SetHeightIcon, BedStatusIcon } from '../../../../components/Icon';
import { SetHeight, Delete, Rename } from '../TemplateEdit/list';
import { i18n } from '../../../../language';
import TeamDetails from '../../components/TemplateEdit/TeamDetailsPopup';
import { DutyContext } from '../..';
import BedStatusSetting from '../TemplateEdit/BedStatusSetting';
import ColorSelecter from '../ColorSelecter/colorSelecter';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '18.25rem',
    padding: '1.313rem 0rem 1.25rem 0.938rem',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0.9375rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '18.25rem',
      height: '0.25rem',
      backgroundColor: theme.palette.staff.purple,
      zIndex: '9',
    },
  },
  rootLeave: {
    width: '18.25rem',
    padding: '1.313rem 0 1.25rem 0.938rem',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0.9375rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '18.25rem',
      height: '0.25rem',
      backgroundColor: theme.palette.font.sub,
      zIndex: '9',
    },
  },
  head: {
    marginBottom: '0.938rem',
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    width: '14rem',
    fontWeight: '600',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  startEndTime: {
    color: theme.palette.font.main,
    fontSize: '0.938rem',
    marginRight: '1rem',
  },
  moreicon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
    marginRight: '0.938rem',
  },
  menu: {
    '& .MuiMenu-paper': {
      boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    },
    borderRadius: '0.16875rem',
    '& .MuiPopover-paper': {
      overflow: 'none',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        marginLeft: '-0.688rem',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.78rem',
        left: '50%',
        marginLeft: '-0.8rem',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  menuitem: {
    padding: '1rem',
    height: '3.75rem',
    width: '100%',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    borderTop: '0.0625rem solid #e4e7eb',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  renameIcon: {
    color: theme.palette.font.main,
    fontSize: '0.938rem',
    marginRight: '1rem',
  },
  body: {
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px', backgroundColor: '#f9f9f9' },
    '&::-webkit-scrollbar-track': {
      background: '#fafafa',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#c1c1c1',
      borderRadius: '4px',
      border: '2px solid #f8f8f8',
    },
    '&::-webkit-scrollbar-thumb:hover': { background: '#a8a8a8' },
  },
}));

function List({
  head,
  height,
  headcolor,
  cardList,
  setOndutyList,
  ondutyList,
  publishCtrl,
  listIndex,
  srsMapping,
  staffList,
  handleEdit,
  listID,
  dutyTemplateGroupId,
  dutyCheckList,
  enableSmartComm,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [heightOpen, setHeightOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [renameOpen, setRenameOpen] = useState(false);
  const [openTeamDetails, setOpenTeamDetails] = useState(false);
  const [openBedStatus, setOpenBedStatus] = useState(false);
  const { isSort } = useContext(DutyContext);
  const refColorSelecter = useRef();
  const [anchorPosition, setAnchorPosition] = useState({ left: 0, top: 0 });
  const [selectedCardElementId, setSelectedCardElementId] = useState('');
  const smartComm = enableSmartComm;
  const ruleCodeInit = {
    srsUnitCode: 'srsUnitCode',
    srsRankCode: 'srsRankCode',
    srsShiftCode: 'srsShiftCode',
  };

  const editData =
    ondutyList?.length > 0
      ? {
          title: head,
          chatStartAt: ondutyList[listIndex]?.chatStartAt,
          chatEndAt: ondutyList[listIndex]?.chatEndAt,
          chatBufferEnterAt: ondutyList[listIndex]?.chatBufferEnterAt,
          chatBufferLeaveAt: ondutyList[listIndex]?.chatBufferLeaveAt,
          dutyChats: ondutyList[listIndex]?.dutyChats,
        }
      : {};

  const bedStatusData =
    ondutyList?.length > 0
      ? {
          bsTeamType: ondutyList[listIndex]?.bsTeamType,
          bsVisible: ondutyList[listIndex]?.bsVisible,
        }
      : {};

  useEffect(() => {
    let list = [];
    let mapping = [];

    if (Array.isArray(srsMapping) && srsMapping.length > 0) {
      mapping = _.map(
        srsMapping.filter((item) => {
          return item.srsUnitCode && item.srsRankCode && item.srsShiftCode;
        }),
        (item) => {
          return {
            [ruleCodeInit.srsUnitCode]: item.srsUnitCode.split(','),
            [ruleCodeInit.srsRankCode]: item.srsRankCode.split(','),
            [ruleCodeInit.srsShiftCode]: item.srsShiftCode.split(','),
          };
        }
      );
    }

    if (staffList && mapping.length > 0) {
      list = _.map(
        _.filter(staffList, (item) => {
          const mapLength = mapping.length;
          for (let i = 0; i < mapLength; i++) {
            if (
              _.some(mapping[i][ruleCodeInit.srsUnitCode], (rule) => rule === item[ruleCodeInit.srsUnitCode]) &&
              _.some(mapping[i][ruleCodeInit.srsRankCode], (rule) => rule === item[ruleCodeInit.srsRankCode]) &&
              _.some(mapping[i][ruleCodeInit.srsShiftCode], (rule) => rule === item[ruleCodeInit.srsShiftCode])
            ) {
              return true;
            }
          }
          return false;
        }),
        (item) => {
          return {
            ...item,
            listIndex: listIndex,
            cardList: cardList,
          };
        }
      );
    }

    if (list.length > 0) {
      setOndutyList((preList) => {
        preList[listIndex].dutyStaffs = list;
        return preList;
      });
    }
  }, [staffList, srsMapping]);

  const handleClick = (event) => {
    // setAnchorEl(event.currentTarget);
    setSelectedCardElementId(event.currentTarget.id);
    setAnchorEl(event);
    setAnchorPosition({
      top: event.clientY - event.nativeEvent?.layerY + event.currentTarget?.clientHeight * 1.2,
      left: event.clientX - event.nativeEvent?.layerX + event.currentTarget?.clientWidth * 0.7,
    });
  };

  const handleClose = () => {
    setSelectedCardElementId('');
    setAnchorEl(null);
  };

  const handleDelete = (props) => {
    setOndutyList((preList) => {
      preList[listIndex].dutyStaffs.splice(props, 1);
      return preList;
    });
  };

  const handleHighlight = (index, color) => {
    setOndutyList((preList) => {
      preList[listIndex].dutyStaffs[index].color = color;
      return preList;
    });
  };

  const handleAddRemarks = (index, remark, longremark) => {
    setOndutyList((preList) => {
      preList[listIndex].dutyStaffs[index].remark = remark;
      preList[listIndex].dutyStaffs[index].longremark = longremark;
      return preList;
    });
  };

  const handleSetStartEndTime = (index, chatStartAt, chatEndAt) => {
    setOndutyList((preList) => {
      preList[listIndex].dutyStaffs[index].dutyStartAt = chatStartAt;
      preList[listIndex].dutyStaffs[index].dutyEndAt = chatEndAt;
      return preList;
    });
  };

  const handleRename = (name) => {
    setOndutyList((preList) => {
      preList[listIndex].title = name;
      return preList;
    });
    handleEdit(false);
  };

  const handleEditTeamDetails = (saveData) => {
    if (ondutyList) {
      ondutyList[listIndex].title = saveData.title;
      ondutyList[listIndex].chatStartAt = saveData.chatStartAt;
      ondutyList[listIndex].chatEndAt = saveData.chatEndAt;
      ondutyList[listIndex].chatBufferEnterAt = saveData.chatBufferEnterAt;
      ondutyList[listIndex].chatBufferLeaveAt = saveData.chatBufferLeaveAt;
      ondutyList[listIndex].dutyChats = saveData.dutyChats;
      setOndutyList([...ondutyList]);
      handleEdit(false);
    }
  };

  const handleSettingBedStatus = (saveData) => {
    if (ondutyList) {
      ondutyList[listIndex].bsTeamType = saveData.bsTeamType;
      ondutyList[listIndex].bsVisible = saveData.bsVisible;
      setOndutyList([...ondutyList]);
      handleEdit(false);
    }
  };

  const handleDeleteCubicle = () => {
    setOndutyList((preList) => {
      preList.splice(listIndex, 1);
      return preList;
    });
    handleEdit(false);
  };

  const handleAddCubicle = () => {
    setOndutyList((preList) => {
      const maxId = Math.max(...preList.map((item) => item.id));
      return [...preList, { id: maxId + 1, title: 'New Cubicle', height: 4, dutyStaffs: [] }];
    });
    handleEdit(false);
  };

  const handleHeight = () => {
    return height * 4.5;
  };

  const handleSetHeight = (props) => {
    setOndutyList((preList) => {
      preList[listIndex].height = props;
      return preList;
    });
    handleEdit(false);
  };

  const numberToTime = (duration) => {
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const hourStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minuteStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${hourStr}:${minuteStr}`;
  };

  let ColorArr = [classes.root, classes.rootLeave];
  const chatEndAtString = () => {
    if (numberToTime(ondutyList[listIndex]?.chatEndAt) === '00:00') {
      return '24:00';
    } else {
      return numberToTime(ondutyList[listIndex]?.chatEndAt);
    }
  };
  const startEndTime =
    ondutyList?.length > 0 &&
    ondutyList[listIndex]?.chatStartAt !== null &&
    ondutyList[listIndex]?.chatStartAt !== undefined
      ? `${numberToTime(ondutyList[listIndex]?.chatStartAt)} - ${chatEndAtString()}`
      : null;
  return (
    <div
      className={ColorArr[headcolor]}
      style={{
        backgroundColor: ondutyList[listIndex]?.bodyBackgroundColor || '#ffffff',
        opacity: `DutyAssign-ButtonBase-aef-${listID}` === selectedCardElementId ? 0.5 : 1,
        boxShadow:
          `DutyAssign-ButtonBase-aef-${listID}` !== selectedCardElementId
            ? '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)'
            : '0 0 1rem 0 rgba(0, 0, 0, 1)',
      }}
    >
      <div className={classes.head}>
        <div>
          <div className={classes.title} title={head}>
            {head}
          </div>
          <div className={classes.startEndTime}>{startEndTime}</div>
        </div>

        {publishCtrl && (
          <div>
            <ButtonBase
              onClick={handleClick}
              id={`DutyAssign-ButtonBase-aef-${listID}`}
              style={{ backgroundColor: ondutyList[listIndex]?.bodyBackgroundColor || '#ffffff' }}
            >
              <MoreIcon className={classes.moreicon} />
            </ButtonBase>
            <Menu
              className={classes.menu}
              anchorEl={anchorEl}
              open={open}
              id={`DutyAssign-Menu-aeg-${listID}`}
              onClose={handleClose}
              keepMounted
              anchorReference="anchorPosition"
              anchorPosition={anchorPosition}
            >
              <MenuItem
                style={{ border: '0' }}
                className={classes.menuitem}
                onClick={() => {
                  handleClose();
                  setOpenTeamDetails(true);
                }}
                id={`DutyAssign-MenuItem-aei-${listID}`}
              >
                <ReNameIcon className={classes.renameIcon} style={{ marginRight: '1.4rem' }} />
                {i18n.t('DUTYASSIGN_TEAMDETAILS_TEAM_DETAILS_EDIT')}
              </MenuItem>
              <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  handleClose();
                  setDeleteOpen(true);
                }}
                id={`DutyAssign-MenuItem-aei-${listID}`}
              >
                <CloseIcon className={classes.renameIcon} style={{ fontSize: '1rem', marginRight: '1.4rem' }} />
                {i18n.t('DUTYASSIGN_LIST_DELETE')}
              </MenuItem>
              <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  handleClose();
                  handleAddCubicle();
                }}
                id={`DutyAssign-MenuItem-aej-${listID}`}
              >
                <AddIcon className={classes.renameIcon} style={{ fontSize: '1.125rem', marginRight: '1.3rem' }} />
                {i18n.t('DUTYASSIGN_LIST_ADD')}
              </MenuItem>
              <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  handleClose();
                  setHeightOpen(true);
                }}
                id={`DutyAssign-MenuItem-aek-${listID}`}
              >
                <SetHeightIcon className={classes.renameIcon} style={{ fontSize: '1.25rem', marginRight: '1.2rem' }} />
                {i18n.t('DUTYASSIGN_LIST_SET')}
              </MenuItem>
              <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  handleClose();
                  refColorSelecter.current.init();
                  refColorSelecter.current.setDialogTitle(i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SET_BACKGROUND_COLOR'));
                  refColorSelecter.current.setSelectedColor(ondutyList[listIndex]?.bodyBackgroundColor || '');
                  refColorSelecter.current.setOnConfirm((selectedColor) => {
                    setOndutyList((preList) => {
                      preList[listIndex].bodyBackgroundColor = selectedColor;
                      return preList;
                    });
                    refColorSelecter.current.close();
                  });
                  refColorSelecter.current.open();
                }}
                id="DutyAssign-MenuItem-bgc"
              >
                <div className={classes.renameIcon}>
                  <FormatColorFill className={classes.Icon} style={{ fontSize: '1.3rem', marginRight: '0.1rem' }} />
                </div>
                {i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SET_BACKGROUND_COLOR')}
              </MenuItem>
              {/* <MenuItem
                className={classes.menuitem}
                onClick={() => {
                  handleClose();
                  setOpenBedStatus(true);
                }}
                id={`DutyAssign-MenuItem-aei-${listID}`}
              >
                <BedStatusIcon className={classes.renameIcon} style={{ fontSize: '1rem', marginRight: '1.4rem' }} />
                {i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TITLE')}
              </MenuItem> */}
              <SetHeight
                open={heightOpen}
                id="DutyAssign-SetHeight-ael"
                setopen={setHeightOpen}
                handleSetHeight={handleSetHeight}
                height={height}
              />
              <Delete
                open={deleteOpen}
                id="DutyAssign-Delete-aem"
                setopen={setDeleteOpen}
                handleDelete={handleDeleteCubicle}
              />
              <Rename
                open={renameOpen}
                id="DutyAssign-Rename-aen"
                setopen={setRenameOpen}
                handleRename={handleRename}
                title={head}
              />
              {openTeamDetails && (
                <TeamDetails
                  closePop={() => {
                    setOpenTeamDetails(false);
                  }}
                  open={openTeamDetails}
                  id="DutyAssign-Rename-team-details"
                  title={i18n.t('DUTYASSIGN_TEAMDETAILS_TEAM_DETAILS')}
                  oldData={JSON.stringify(editData)}
                  confirmClick={handleEditTeamDetails}
                  isEnableSmartComm={smartComm}
                  isTemplate={false}
                />
              )}
              <ColorSelecter ref={refColorSelecter} />
              {openBedStatus && (
                <BedStatusSetting
                  closePop={() => {
                    setOpenBedStatus(false);
                  }}
                  open={openBedStatus}
                  id="DutyAssign-setting-bed-status"
                  title={i18n.t('DUTYASSIGN_ROSTER_SETTING_BED_STATUS_TITLE')}
                  oldData={JSON.stringify(bedStatusData)}
                  confirmClick={handleSettingBedStatus}
                />
              )}
            </Menu>
          </div>
        )}
      </div>
      <Droppable droppableId={JSON.stringify({ dutyTemplateGroupId, listIndex })}>
        {(provided) => (
          <div
            className={classes.body}
            style={{
              maxHeight: `${handleHeight()}rem`,
              height: cardList.length === 0 ? '4.5rem' : 'auto',
              backgroundColor: ondutyList[listIndex]?.bodyBackgroundColor || '#ffffff',
            }}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {_.orderBy(
              cardList,
              isSort === 1 ? [] : ['dutyStartAt', 'dutyEndAt', 'rankOrder', 'name'],
              isSort === 1 ? [] : ['asc', 'asc', 'asc', 'asc']
            ).map((item, index) => (
              <Card
                {...item}
                itemProps={item}
                publishCtrl={publishCtrl}
                drop={true}
                handleDelete={handleDelete}
                handleHighlight={handleHighlight}
                handleAddRemarks={handleAddRemarks}
                handleSetStartEndTime={handleSetStartEndTime}
                handleEdit={handleEdit}
                listIndex={listIndex}
                cardList={cardList}
                index={index}
                setOndutyList={setOndutyList}
                key={item.id}
                id={`${listID}___${item.id}`}
                cardId={item.id}
                staff={false}
                temporary={false}
                isSort={isSort}
                dutyCheckList={dutyCheckList}
                enableSmartComm={smartComm}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLogin: state.loginInfo.flag,
});

export default connect(mapStateToProps)(List);
